import React from "react";

import { useIntl } from "react-intl";

import { LoadingSpinner } from "@mapmycustomers/ui";

import styles from "./Loader.module.scss";

interface Props {}

const Loader: React.FC<Props> = () => {
  const intl = useIntl();

  return (
    <div className={styles.container}>
      <LoadingSpinner mini />
      <div className={styles.text}>
        {intl.formatMessage({
          id: "frequency.cadenceSelector.checkingFrequencyStatus",
          defaultMessage: "Checking frequency status",
          description: "frequency component - Checking frequency status",
        })}
      </div>
    </div>
  );
};

export default Loader;
